import useLazySelector from "common/redux/useLazySelector";
import * as MerchantActions from 'features/merchants/merchants.actions';
import FormFieldSetting from "domain/formFieldSetting";

const defaultVal: FormFieldSetting[] = [];
export default function useFormFieldSettings(): FormFieldSetting[] {
    return useLazySelector(store => store.formFieldSettings, MerchantActions.loadMerchantFormFieldSettings, null, defaultVal);
}